import m, {Vnode} from "mithril";
import {TextboxItem} from "../../../../model/items/textbox";
import KandidatDefault from "./KandidatDefault";

export default class KandidatiControls {

    private readonly step: number;
    private readonly unit: string;
    private readonly min = 0;
    private readonly max: number;

    private focused = false;
    private self: KandidatiControls;

    constructor(
        private readonly input: TextboxItem,
        public readonly kandidat: KandidatDefault
    ) {
        this.unit = input.form.aux1 || "";
        this.step = Number(input.form.aux2 || 1) || 1;
        this.max = Number(input.form.aux3 || Infinity) || Infinity;
        this.self = this;
    }

    public getValue(): number {
        return this.readInputVariable();
    }

    public isFocused(): boolean {
        return this.focused;
    }

    private numerize(value: any): number {
        return Number( (''+value).replace(',', '.').replace(/\s/g, ''));
    }

    private readInputVariable(): number {
        return Number(this.numerize(this.input.getVariable()) || 0) || 0;
    }

    private set(value: string|number): void {
        const numeric = this.numerize(value);
        if (!isNaN(numeric)) {
            this.input.setVariable(
                Math.min(this.max, Math.max(this.min, this.round(numeric)))
            );
            this.kandidat.kandidati.triggerChange();
        }
    }

    private minus(): void {
        this.set( Math.max(this.readInputVariable() - this.step, this.min) );
    }

    private plus(): void {
        this.set( Math.min(this.readInputVariable() + this.step, this.max) );
    }

    private round(value: number): number {
        return this.kandidat.kandidati.round(value);
    }

    public view(): Vnode {
        return m('.kandidat-controls', {}, [
            m('button.btn', {
                onclick: () => this.minus(),
            }, [
                m('.icon.icon-minus')
            ]),
            m('.input-group', {}, [
                m('input[type="text"]', {
                    value: this.focused ? undefined : this.readInputVariable().toLocaleString(),
                    onfocus: () => this.self.focused = true,
                    onblur: () => this.self.focused = false,
                    oninput: (e: InputEvent) => this.set((<HTMLInputElement>e.currentTarget).value),
                    onkeydown: (e: KeyboardEvent) => {
                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault();
                            if (e.key === 'ArrowUp') {
                                this.plus();
                            } else if (e.key === 'ArrowDown') {
                                this.minus();
                            }
                            (<HTMLInputElement>e.currentTarget).value = this.readInputVariable().toLocaleString();
                        }
                    }
                }),
                m('span.unit', {}, this.unit)
            ]),
            m('button.btn', {
                onclick: () => this.plus(),
            }, [
                m('.icon.icon-plus-circle-outline')
            ]),
        ])
    }

}
